import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@awesome.me/kit-2be97ecbd6/icons/classic/solid';
import { useQuery } from '@tanstack/react-query';
import clsx from 'clsx';

import { getRiverSummary } from './api/Rivers.js';
import RiverSummary from './components/RiverSummary.jsx';
import BottomBarArea from './components/BottomBarArea.jsx';

import hero1 from './assets/images/hero1.jpg';
import styles from './Root.module.css';

const REFETCH_INTERVAL = 900000;

function Root() {
  const { isError, data } = useQuery({
    queryKey: ['rivers', 'summary'],
    queryFn: getRiverSummary,
    refetchInterval: REFETCH_INTERVAL,
  });

  return (
    <>
      <div
        className={clsx(styles.HeroBackground, 'bg-dark', 'text-secondary')}
        style={{ backgroundImage: `url("${hero1}")` }}
      >
        <div className={styles.HeroOverlay}>
          <Container className="py-5">
            <h1 className="display-5 text-white">Live Townsville River Conditions</h1>
            <Col xs={10} md={8} lg={6}>
              <p className="fs-5 mb-4 text-white">
                Townsville's critical river and flood information all in one place.
              </p>
            </Col>
          </Container>
        </div>
      </div>
      <div className={styles.RiverSummary}>
        <Container>
          <Row>
            <Col xs={12} sm={6} md={3} lg={3} className={styles.RiverSummaryCol}>
              <RiverSummary river={getDataRiverSummary(data, 'ross')} error={isError} title={'Ross River'} link={'/rivers/ross'} />
            </Col>
            <Col xs={12} sm={6} md={3} lg={3} className={styles.RiverSummaryCol}>
              <RiverSummary river={getDataRiverSummary(data, 'bohle')} error={isError} title={'Bohle River'} link={'/rivers/bohle'} />
             </Col>
            <Col xs={12} sm={6} md={3} lg={3} className={styles.RiverSummaryCol}>
              <RiverSummary river={getDataRiverSummary(data, 'black')} error={isError} title={'Black River'} subtitle={'and Bluewater Creek'} link={'/rivers/black'} />
            </Col>
            <Col xs={12} sm={6} md={3} lg={3} className={styles.RiverSummaryCol}>
              <RiverSummary river={getDataRiverSummary(data, 'alligator')} error={isError} title={'Alligator Creek'} link={'/rivers/alligator'} />
            </Col>
          </Row>
        </Container>
      </div>
      <BottomBarArea>

      </BottomBarArea>
    </>
  );
}

function getDataRiverSummary(data, riverKey) {
  return data?.rivers?.find((river) => river.key === riverKey);
}

export default Root;
